import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { getLookupList, deleteLookupDetails } from "../../Actions/lookupAPI";
import { confirmAlert } from "react-confirm-alert";
import CommonCard from "./ClassCard";
import AddIcon from "../../UIComponents/AddIcon";
import $ from "jquery";
import axios from "axios";
import Role from "../../helpers/role";
import API from "../../helpers/api";
import { toast } from "react-toastify";
import ClassEdit from "./ClassEdit";
let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");
class Class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleName: "",
      SelectedLanguage: "",
      searchData: {
        LookUpToSearch: "class",
        LookUpName: "",
        PageNumber: 1,
        PageSize: 20,
      },
    };
    this.SearchLookup = this.SearchLookup.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
  }
  /*   componentDidUpdate(prevProps) {
    if (prevProps.LookupClear) {
      this.getLookup();
      this.props.dispatch({ type: "LookupClear", data: false });
    }
  } */
  componentDidMount() {
    const { dispatch, match, classSearch, t } = this.props;
    if (classSearch) {
      this.state.searchData = classSearch;
    }
    const { params } = match;
    dispatch({ type: "SubBannerTitle", data: "Class" });
    var Language = $("#Multi-language").find(":selected").val();
    if (Language) {
      this.setState({ SelectedLanguage: Language });
    }
    this.state.searchData.LookUpName = "";
    this.setState({});
    this.getLookup();
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (_this.state.searchData.LookUpName != "") {
          _this.SearchLookup(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  getLookup() {
    this.props.dispatch(getLookupList(this.state.searchData));
  }

  SearchLookup(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "classSearch", data: this.state.searchData });
    dispatch(getLookupList(this.state.searchData));
  }

  SearchLookup1(pgno) {
    const { dispatch, t } = this.props;
    if (this.state.searchData.LookUpName !== "") {

      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "classSearch", data: this.state.searchData });
      dispatch(getLookupList(this.state.searchData));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    const { dispatch } = this.props;
    let nodeName = e.target.name;
    this.state.searchData.LookUpToSearch = "class";
    this.state.searchData.LookUpName = e.target.value;
    this.setState({});
  }

  ClearInput() {
    this.state.searchData.LookUpName = "";
    this.state.searchData.PageNumber = 1;
    this.state.searchData.PageSize = 20;
    this.setState({});
    this.props.dispatch({ type: "classSearch", data: this.state.searchData });
    this.props.dispatch(getLookupList(this.state.searchData));
  }
  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "classDetails", data: item });
    history.push(`/Home/LookupClassEdit/${item.lookUpId}`);
    dispatch({ type: "ClassApplicableServices", data: "" });
  }
  deleteClass(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch } = this.props;
            let lookup = {
              lookUpId: item.lookUpId,
              lookUpType: "class",
              lookUpToUpdate: "lookup",
              lookUpName: item.lookUpName,
              classAttachmentName: item.classAttachmentName,
              classAttachmentGuid: item.classAttachmentGuid,
              isDeleted: true,
              modifiedBy: currentuser.name,
            };
            dispatch(deleteLookupDetails(lookup, "Class", t));
            this.state.searchData.LookUpName = "";
            this.ClearInput()
            this.setState({})
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  }
  render() {
    const { showSidePane, LookupList, match, t } = this.props;
    const { params } = match;
    const { type } = params;
    const { flagList, titleName } = this.state;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className=" card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("ClassScreen.Title")}
                        </h5>
                        <div
                          className="m-1 flex"
                          onClick={() => this.Addlookup()}
                        >
                          <span className="mt-1">
                            {t("ShipManagementContent.Add")}
                          </span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        <div className="col-lg-6 m-auto">
                          <label className="form-label">
                            {t("ClassScreen.Title")}
                          </label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name={this.state.titleName}
                            value={this.state.searchData.LookUpName}
                            placeholder={t("ClassScreen.Title")}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className="col-lg-6">
                          <br></br>

                          <div
                            className="search-btn-col pt-3"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchLookup1(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {LookupList ? (
                <CommonCard
                  currentPage={(LookupList.pagination.currentPage - 1) * LookupList.pagination.pageSize}
                  arraylist={LookupList.data}
                  titleName={this.state.titleName}
                  totalRecords={
                    LookupList.pagination.totalcount
                      ? LookupList.pagination.totalcount
                      : 0
                  }
                  pageSize={LookupList.pagination.pageSize}
                  setUpdatedState={(value) => this.SearchLookup(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteClass={(item) => this.deleteClass(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }

  Addlookup = () => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/LookupClassAdd`);
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    LookupList: state.lookupReducer.LookupList,
    LookupClear: state.lookupReducer.LookupClear,
    classSearch: state.lookupReducer.classSearch,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Class)
);
